import { isMocking, mockedEvent, getMockSocket } from 'api/mockupUtils'
// import DATA_TMPL from 'data/mocks/mc/newGameTemplate.json'
// import DATA_BOTS_DEFAULT_VALUES from 'data/mocks/mc/botsDefaultValues.json'
// import DATA_GAME from 'data/mocks/mc/game.json'
import DATA_GAME_LIST from 'data/mocks/mc/gameList.json'

export default socket => ({
    requestNewGameTemplate: () => {
        console.tron.log('SOCKET EMMIT - mc_request_new_game_template')
        // socket.emit(mockedEvent('mc_request_new_game_template'), isMocking || true ? getMockSocket('mc_new_game_template', DATA_TMPL) : {})
        socket.emit('mc_request_new_game_template')
    },
    requestNewGame: data => {
        console.tron.log('SOCKET EMMIT - mc_request_new_game')
        console.tron.log(data)
        // socket.emit(mockedEvent('mc_request_new_game'), isMocking || true ? getMockSocket('mc_new_game', { gameCode: 'XXXXXX' }) : {})
        socket.emit('mc_request_new_game', data)
    },
    requestGameBotsDefaultValues: data => {
        console.tron.log('SOCKET EMMIT - mc_request_game_bots_default_values')
        console.tron.log(data)
        // socket.emit(mockedEvent('mc_request_game_bots_default_values'), isMocking || true ? getMockSocket('mc_game_bots_default_values', DATA_BOTS_DEFAULT_VALUES) : {})
        socket.emit('mc_request_game_bots_default_values', data)
    },
    updateGameBots: data => {
        console.tron.log('SOCKET EMMIT - mc_game_update_bots')
        console.tron.log(data)
        // socket.emit(mockedEvent('mc_game_update_bots'), isMocking || true ? getMockSocket('mc_game_bots_updated', {}) : {})
        socket.emit('mc_game_update_bots', data)
    },
    requestGame: data => {
        console.tron.log('SOCKET EMMIT - mc_request_game')
        console.tron.log(data)
        // socket.emit(mockedEvent('mc_request_game'), isMocking || true ? getMockSocket('mc_game', DATA_GAME) : {})
        socket.emit('mc_request_game', data)
    },
    requestGameList: () => {
        console.tron.log('SOCKET EMMIT - mc_request_decisions_list')
        // socket.emit(mockedEvent('mc_request_decisions_list'), isMocking || true ? getMockSocket('mc_decisions_list', DATA_GAME_LIST) : {})
        socket.emit('mc_request_decisions_list')
    },
    requestGameCSV: data => {
        console.tron.log('SOCKET EMMIT - mc_request_decision_csv')
        console.tron.log(data)
        socket.emit('mc_request_decision_csv', data)
    },

    testGameLog: log => {
        console.tron.log('SOCKET EMMIT - test__log')
        console.tron.log(log)
        socket.emit(mockedEvent('test__log'), getMockSocket('mc_game_log', log))
        // socket.emit('mc_request_game', data)
    }
})



// WEBPACK FOOTER //
// src/api/emitters/mc.js